<template>
  <div
    v-if="showManagedTemplates"
    :class="$style.container"
  >
    <HeadingSmall>
      <IconButton
        :class="$style.backButton"
        data-test-id="TabView__BackIconButton"
        hasNoBackground
        icon="arrowLeft"
        text="Commands Home"
        type="informational"
        @click="handleBackButtonClick"
      />
    </HeadingSmall>
    <HeadingMedium :class="$style.headText">
      Manage Templates
    </HeadingMedium>
    <CommandTemplateManageItemTable />
  </div>
</template>

<script>

import {
  HeadingMedium,
  HeadingSmall,
  IconButton,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, ItemTypeRoutes, StoreModuleMap } from 'client/util/Constants';
import { extend, noop } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import CommandTemplateManageItemTable from 'client/Commands/CommandTemplateManageItemTable.vue';
import MspState from 'client/components/models/MspState';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'CommandTemplateManageMainPanel',
  components: {
    CommandTemplateManageItemTable,
    HeadingMedium,
    HeadingSmall,
    IconButton,
  },

  data() {
    return {
      items: [],
    };
  },

  computed: {
    ...mapState(settingsModule, [
      'orgId',
      'user',
    ]),
    ...mapGetters(settingsModule, [
      'isAdminWithBilling',
      'isAdmin',
    ]),
    showManagedTemplates() {
      return this.$hasFeatureFlag(this.$featureFlags.commandTemplateEdit)
      && MspState.isAnMsp
      && (this.isAdminWithBilling || this.isAdmin);
    },
  },

  beforeCreate() {
    const storeModel = StoreModuleMap[ItemTypeConsts.commandTemplate];
    /**
     * Extend the computed properties and methods here, before the component is
     * created so that the namespace argument to mapActions() and mapGetters()
     * can be set dynamically from the props passed to the ItemTable component.
     * @see https://github.com/vuejs/vuex/issues/863#issuecomment-315619012
     */

    extend(
      this.$options.methods,
      mapActions(storeModel, {
        setProviderId: 'setProviderId',
        setOrganizationId: 'setOrganizationId',
      }),
    );
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    handleBackButtonClick() {
      const commandRoute = ItemTypeRoutes[ItemTypeConsts.command];
      this.$router.push(commandRoute).catch(noop);
    },

    handleMounted() {
      this.setOrganizationId(this.orgId);
      if (MspState.isAnMsp) {
        this.setProviderId(this.user.provider);
      }
    },
  },
};
</script>

  <style module>
  .recommendedCommandQueue button {
    background: none;
    cursor: pointer;
    text-decoration: underline;
  }

  .copyWell {
    margin: 0 0 -2.5em 0;
    width: 100%;
  }

  .container {
    height: 100%;
  }

  /* Require "!important" to overwrite the default component styles because
    it has several selectors that weigh more than the class.

    Overrides https://github.com/TheJumpCloud/jumpcloud-ui-components/blob/master/src/components/Inputs/CopyWell/CopyWell.vue#L271
  */

  .headText {
    margin-bottom: 0;
    margin-left: 1em !important;
  }

  .backButton.backButton {
    margin-bottom: 0;
    margin-left: 2em;
    margin-top: 1.2em;
  }
  </style>
